import { render, staticRenderFns } from "./hotTrans.vue?vue&type=template&id=9e865962&"
import script from "./hotTrans.ts?vue&type=script&lang=ts&"
export * from "./hotTrans.ts?vue&type=script&lang=ts&"
import style0 from "./hotTrans.vue?vue&type=style&index=0&id=9e865962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports